import axiosInstance from "./axiosInstance";
import BASE_URL from "../config/apiConfig";

export const changePassword = async (currentPassword, newPassword, username) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/auth/change-password`, {
      current_password: currentPassword,
      new_password: newPassword,
      username,
    });
    return response.data; // You can return the response if needed for further use
  } catch (error) {
    console.error('Error changing password:', error);
    
    const errorMessage = 
      error.response?.data?.detail ||
      error.response?.data?.message ||
      error.response?.data?.error ||
      (typeof error.response?.data === 'string' ? error.response.data : null) ||
      error.message ||
      'Failed to change password. Please check your current password and try again.';
    
    throw new Error(errorMessage);
  }
};